import type { ReactNode } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';

export function DashboardLayout(): ReactNode {
  const navigate = useNavigate();
  const { user, tenant, logout } = useAuthStore();

  const handleLogout = (): void => {
    void (async (): Promise<void> => {
      try {
        await logout();
        await navigate('/login');
      } catch {
        // Logout errors are handled by the store
      }
    })();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="border-b bg-white">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4">
          <div className="flex items-center gap-8">
            <Link to="/" className="text-xl font-bold text-primary-600">ProfitOS</Link>
            <nav className="hidden md:flex items-center gap-6">
              <Link to="/" className="text-sm font-medium text-gray-700 hover:text-primary-600">
                Dashboard
              </Link>
              <Link to="/marketplace" className="text-sm font-medium text-gray-700 hover:text-primary-600">
                Marketplace
              </Link>
              <Link to="/offers" className="text-sm font-medium text-gray-700 hover:text-primary-600">
                Offers
              </Link>
              <Link to="/content" className="text-sm font-medium text-gray-700 hover:text-primary-600">
                Content
              </Link>
              <Link to="/links" className="text-sm font-medium text-gray-700 hover:text-primary-600">
                Links
              </Link>
              <Link to="/analytics" className="text-sm font-medium text-gray-700 hover:text-primary-600">
                Analytics
              </Link>
              <Link to="/publishing" className="text-sm font-medium text-gray-700 hover:text-primary-600">
                Publishing
              </Link>
              <Link to="/team" className="text-sm font-medium text-gray-700 hover:text-primary-600">
                Team
              </Link>
              <Link to="/integrations" className="text-sm font-medium text-gray-700 hover:text-primary-600">
                Integrations
              </Link>
              <Link to="/settings" className="text-sm font-medium text-gray-700 hover:text-primary-600">
                Settings
              </Link>
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-right">
              <p className="text-sm font-medium text-gray-900">{user?.name ?? user?.email}</p>
              <p className="text-xs text-gray-500">{tenant?.name}</p>
            </div>
            <button
              onClick={handleLogout}
              className="text-sm font-medium text-gray-600 hover:text-gray-900"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
